const parse = (input) => {
    if (typeof input !== 'string') {
        throw new Error('Invalid input: input should be a string');
    }

    const lines = input.split(/\r?\n/);
    const cues = [];
    let cue = null;
    let note = '';
    let bookmark = false;

    lines.forEach((line, index) => {
        try {
            if (line.startsWith('NOTE')) {
                const noteParts = line.split(' ');
                if (noteParts.includes('BOOKMARK')) {
                    bookmark = true;
                    note = noteParts.slice(2).join(' ');
                } else {
                    note = noteParts.slice(1).join(' ');
                }
            } else if (line.includes('-->')) {
                if (cue) {
                    cue.note = note;
                    cue.bookmark = bookmark;
                    cue.text = cue.text.replace(/^\s+|\s+$/gm, '');
                    cues.push(cue);
                    note = '';
                    bookmark = false;
                }
                cue = parseCue(line);
            } else if (cue) {
                cue.text += (cue.text ? '\n' : '') + line;
            }
        } catch (error) {
            throw new Error(`Error parsing line ${index + 1}: ${error.message}`);
        }
    });

    if (cue) {
        cue.note = note;
        cue.bookmark = bookmark;
        cues.push(cue);
    }

    return { cues };
};

const parseCue = (line) => {
    const timeAndStyles = line.split(' --> ');
    if (timeAndStyles.length !== 2) {
        throw new Error('Invalid cue format');
    }

    const [startTime, rest] = timeAndStyles;
    const [endTime, ...styles] = rest.split(' ');

    return {
        start: parseTime(startTime),
        end: parseTime(endTime),
        text: '',
        note: '',
        bookmark: false,
        styles: styles.join(' '),
    };
};

const parseTime = (timeString) => {
    const parts = timeString.split(':');
    if (parts.length !== 3) {
        throw new Error('Invalid time format');
    }

    const [hours, minutes, seconds] = parts;
    return parseInt(hours, 10) * 3600 + parseInt(minutes, 10) * 60 + parseFloat(seconds);
};

export { parse };
